import { createBaseQuery } from "../helper/createBaseQuery";
import { tokenSlice } from "../slice/tokenSlice";

const reportApi = tokenSlice.injectEndpoints({
  reducerPath: 'report',
  baseQuery: createBaseQuery(),
  endpoints(builder) {
    return {


      getUserReportAccess: builder.query({
        query: (id) => ({
          url: `Report/GetUserReportAccess?reportFileId=${id}`,
          method: "GET",
        }),
        providesTags: ["Report"],
      }),

      getUserReportAccessByCurrentUser: builder.query({
        query: () => {
          return {
            url: 'Report/GetUserReportAccessByCurrentUser',
            method: 'GET'
          }
        }
      }),

      postUserReportAccess: builder.mutation({
        query: (data) => ({
          url: "Report/SaveUserReportAccess",
          method: "POST",
          body: data,
        }),
        providesTags: ["Report"],
      }),


      postSaveAs: builder.mutation({
        query: (data) => ({
          url: "Report/SaveAs",
          method: "POST",
          body: data,
        }),
        providesTags: ["Report"],
      }),

      getDashboards: builder.query({
        query: () => {
          return {
            url: 'Report/GetDashboards',
            method: 'GET'
          }
        }
      }),
    }
  }
})

export const { useGetUserReportAccessQuery, useGetUserReportAccessByCurrentUserQuery, usePostUserReportAccessMutation,
  usePostSaveAsMutation, useGetDashboardsQuery
} = reportApi;
export { reportApi };